import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LMChartBase } from './lm-chart-base';
import { SohoPieComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-chart-pie',
  template: `
    <div soho-pie
        [dataset]="dataset"
        [redrawOnResize]="true"
        [showLegend]="showLegend"
        [animate]="animate"
        [showLines]="showLines"
        [showLinesMobile]="showLinesMobile"
        [hideCenterLabel]="hideCenterLabel"
        [isDonut]="isDonut"
        [lines]="lines"
        [legendPlacement]="legendPlacement"
        [showTooltips]="showTooltips"
        [tooltip]="tooltip"

        (selected)="onSelected($event)"
        (rendered)="onRendered($event)"
        (unselected)="onUnselected($event)"
        (contextmenu)="onContextMenu($event)"
    ></div>
    <!-- FOR Pie CHART
         animationSpeed(value: number)    animate(value: any)    lines(value: SohoPieLinesOptions)  legend(value: SohoPieLegendOptions)
        showTooltips(value: boolean)
    -->
            `
})
export class LMChartPieComponent extends LMChartBase {
  @ViewChild(SohoPieComponent, { static: true }) sohoPieComponent: SohoPieComponent;

  @Input() showLines: boolean;
  @Input() showLinesMobile: boolean;
  @Input() hideCenterLabel: boolean;
  @Input() isDonut: boolean;
  @Input() lines: SohoPieLinesOptions;
  @Input() legendPlacement: string;
  @Input() showTooltips: boolean;

  constructor(
    public elementRef: ElementRef,
  ) {
    super(elementRef);
  }

  public getChartComponent() {
    return this.sohoPieComponent;
  }
}
